export function applyChosenToSelectBoxes() {
  const options = {
    width: '100%',
    search_contains: true
  }

  $('.for_chosen').chosen(options)

  const mobileAgents = /iPhone|iPod|IEMobile|Windows Phone|BlackBerry|BB10|Android.*Mobile/i
  const isMobile = mobileAgents.test(navigator.userAgent)

  if (isMobile) {
    $('.for_chosen').addClass('mobile')
  }
}
